detalleBitacora = function(data){
    let html="";
    if(data){
        Object.entries(data).forEach(([key, value]) => {
            html += `<p class="m-0 p-0"><strong>${key}:</strong> ${value??''}</p>`;
        });
        $("#detalleBitacora").html(html);
    }else{
        html = `<p class="m-0 p-0">Sin información adicional</p>`;
    }
}